import { STRIPE_PUBLIC_KEY } from '@/config/constants'

export default class StripeHelper {
  token: string = ''
  handler: any = null

  constructor(locale: string, StripeCheckout: any) {
    this.handler = StripeCheckout.configure({
      key: STRIPE_PUBLIC_KEY,
      color: 'black',
      image: require('@/assets/agently_logo.png'),
      currency: 'JPY',
      locale: locale,
      token: (token: string) => {
        // You can access the token ID with `token.id`.
        // Get the token ID to your server-side code for use.
        // console.log('token', token)
        this.token = token
        // this.$emit("succeeded", token);
      }
    })
    // console.log('handler', this.handler)
    // console.log('token', this.token)
    window.addEventListener('popstate', () => {
      console.log('token', this.token)
      this.handler.close();
    })
    return this
  }

  // getToken(): string {
  //   return this.token
  // }
}
